(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ncc-cbc-box-picker"] && !Shopify.designMode) return;
  try {
    
  class NccCbcTabs extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#onClick);
      this.addEventListener('keydown', this.#onKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#onClick);
      this.removeEventListener('keydown', this.#onKeydown);
    }

    get tabs() {
      return [...this.querySelectorAll('[role="tab"]')];
    }

    select(tab, focus) {
      for (const t of this.tabs) {
        const on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls') || '');
        if (panel) panel.hidden = !on;
      }
      if (focus) tab.focus();
    }

    #onClick = (event) => {
      const tab = event.target instanceof Element ? event.target.closest('[role="tab"]') : null;
      if (tab) this.select(tab, false);
    };

    #onKeydown = (event) => {
      const tab = event.target instanceof Element ? event.target.closest('[role="tab"]') : null;
      if (!tab) return;
      const tabs = this.tabs;
      const index = tabs.indexOf(tab);
      let next = null;
      if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
      if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
      if (next) {
        event.preventDefault();
        this.select(next, true);
      }
    };
  }

  if (!customElements.get('ncc-cbc-tabs')) {
    customElements.define('ncc-cbc-tabs', NccCbcTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ncc-image-strip"] && !Shopify.designMode) return;
  try {
    
  class NccImageStrip extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.bars = this.querySelector('[data-bars]');
      if (!this.track) return;
      this.track.addEventListener('scroll', this.#onScroll, { passive: true });
      this.querySelector('[data-arrow="previous"]')?.addEventListener('click', () => this.#go(-1));
      this.querySelector('[data-arrow="next"]')?.addEventListener('click', () => this.#go(1));
      this.resizeObserver = new ResizeObserver(() => this.#render());
      this.resizeObserver.observe(this.track);
      this.#render();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.#onScroll);
      this.resizeObserver?.disconnect();
    }

    get pages() {
      if (!this.track) return 1;
      // an overflow of less than one gap (the Figma row is 1291px in a 1280px column) is not a page
      const tolerance = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return Math.max(1, Math.ceil((this.track.scrollWidth - this.track.clientWidth - tolerance) / this.track.clientWidth) + 1);
    }

    get maxScroll() {
      return this.track ? Math.max(0, this.track.scrollWidth - this.track.clientWidth) : 0;
    }

    get page() {
      if (!this.track) return 0;
      const max = this.maxScroll;
      if (max <= 0) return 0;
      // the scroller clamps at the end, so an overflow shorter than a page still counts as the last page
      if (this.track.scrollLeft >= max - 1) return this.pages - 1;
      return Math.min(this.pages - 1, Math.round(this.track.scrollLeft / this.track.clientWidth));
    }

    #target(page) {
      return Math.min(page * this.track.clientWidth, this.maxScroll);
    }

    #onScroll = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.#paint();
      });
    };

    #go(delta) {
      if (!this.track) return;
      const next = Math.min(this.pages - 1, Math.max(0, this.page + delta));
      this.track.scrollTo({ left: this.#target(next), behavior: 'smooth' });
    }

    #render() {
      if (!this.bars) return;
      const pages = this.pages;
      const nav = this.bars.closest('nav');
      if (nav) nav.hidden = pages < 2;
      this.bars.replaceChildren(
        ...Array.from({ length: pages }, (_, i) => {
          const bar = document.createElement('button');
          bar.type = 'button';
          bar.className = 'ncc-pagination__bar';
          bar.setAttribute('aria-label', `${i + 1} / ${pages}`);
          bar.addEventListener('click', () => this.track.scrollTo({ left: this.#target(i), behavior: 'smooth' }));
          return bar;
        })
      );
      this.#paint();
    }

    #paint() {
      const page = this.page;
      const pages = this.pages;
      this.querySelectorAll('.ncc-pagination__bar').forEach((bar, i) => bar.setAttribute('aria-current', i === page ? 'true' : 'false'));
      const prev = this.querySelector('[data-arrow="previous"]');
      const next = this.querySelector('[data-arrow="next"]');
      if (prev) prev.disabled = page <= 0;
      if (next) next.disabled = page >= pages - 1;
    }
  }

  if (!customElements.get('ncc-image-strip')) {
    customElements.define('ncc-image-strip', NccImageStrip);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ncc-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  class NccNewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-dialog]');
      if (!this.dialog) return;
      this.querySelector('[data-close]')?.addEventListener('click', () => this.close(true));
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close(true);
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog && this.hasAttribute('data-modal')) this.close(true);
      });

      if (this.hasAttribute('data-design-mode')) {
        const mine = (event) => event.detail && event.detail.sectionId === this.dataset.sectionId;
        document.addEventListener('shopify:section:select', (event) => mine(event) && this.open());
        document.addEventListener('shopify:section:deselect', (event) => mine(event) && this.close(false));
        return;
      }

      // the sign-up form reloads the page with its result inside the (closed) card: show it straight away
      if (this.querySelector('.email-signup__message')) {
        this.open();
        this.remember();
        return;
      }
      if (this.dismissed() || !this.rendered()) return;
      this.timer = setTimeout(() => this.open(), (parseFloat(this.dataset.delay) || 0) * 1000);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }

    dismissed() {
      try {
        return parseInt(localStorage.getItem(this.dataset.key) || '0', 10) > Date.now();
      } catch (error) {
        return false;
      }
    }

    remember() {
      try {
        const days = parseFloat(this.dataset.days) || 0;
        localStorage.setItem(this.dataset.key, String(Date.now() + days * 86400000));
      } catch (error) {
        /* private mode: the pop-up simply shows again next visit */
      }
    }

    // display: none (the "Show on mobile" switch) would leave a modal dialog blocking the page with nothing to close
    rendered() {
      return typeof this.checkVisibility === 'function' ? this.checkVisibility() : getComputedStyle(this).display !== 'none';
    }

    // NCC (Miles, 2026-09-21): never on top of Shopify's cookie banner - the two cards overlapped below ~1000px.
    // While the banner shows, the card waits for the visitor's answer (Shopify's visitorConsentCollected event,
    // or the banner leaving the page) and opens a beat later.
    bannerShowing() {
      const banner = document.getElementById('shopify-pc__banner');
      if (!banner) return false;
      return typeof banner.checkVisibility === 'function' ? banner.checkVisibility() : banner.offsetParent !== null;
    }

    deferUntilConsent() {
      if (this.deferred) return;
      this.deferred = true;
      const go = () => {
        if (this.opened) return;
        this.opened = true;
        observer.disconnect();
        setTimeout(() => this.open(), 900);
      };
      document.addEventListener('visitorConsentCollected', go, { once: true });
      const observer = new MutationObserver(() => {
        if (!this.bannerShowing()) go();
      });
      observer.observe(document.body, { childList: true, subtree: false, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      const banner = document.getElementById('shopify-pc__banner');
      if (banner) observer.observe(banner, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    }

    open() {
      if (!this.dialog || this.dialog.open || !this.rendered()) return;
      if (!this.hasAttribute('data-design-mode') && this.bannerShowing()) {
        this.deferUntilConsent();
        return;
      }
      if (this.hasAttribute('data-modal')) {
        this.dialog.showModal();
      } else {
        // show() runs the dialog focusing steps (it would focus the close button): hand focus back to the page
        const active = document.activeElement;
        this.dialog.show();
        if (active instanceof HTMLElement && active !== document.body) active.focus({ preventScroll: true });
        else if (this.dialog.contains(document.activeElement)) document.activeElement.blur();
      }
      requestAnimationFrame(() => requestAnimationFrame(() => this.dialog.classList.add('is-open')));
    }

    close(remember) {
      if (!this.dialog || !this.dialog.open) return;
      clearTimeout(this.timer);
      if (remember) this.remember();
      this.dialog.classList.remove('is-open');
      const finish = () => {
        this.dialog.removeEventListener('transitionend', finish);
        if (this.dialog.open) this.dialog.close();
      };
      this.dialog.addEventListener('transitionend', finish);
      setTimeout(finish, 400);
    }
  }

  if (!customElements.get('ncc-newsletter-popup')) {
    customElements.define('ncc-newsletter-popup', NccNewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
